(() => {
  const initialise = () => {
    document.querySelectorAll('[data-photo-wall]:not([data-photo-ready])').forEach(wall => {
      wall.dataset.photoReady = 'true';
      const grid = wall.querySelector('.pp-photo-wall__grid');
      const tiles = [...grid.children];
      for (let i = wall.dataset.photoShuffle === 'false' ? 0 : tiles.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [tiles[i], tiles[j]] = [tiles[j], tiles[i]];
      }
      // Product galleries keep every assigned photo; the homepage shows a sample.
      const limit = wall.hasAttribute('data-product-wall') ? tiles.length : 12;
      tiles.forEach((tile, i) => { if (i < limit) grid.append(tile); else tile.remove(); });
      const photos = tiles.slice(0, limit);
      const more = wall.querySelector('[data-photo-more]');
      if (wall.hasAttribute('data-product-wall') && more && photos.length > 9) {
        more.hidden = false;
        photos.forEach((tile, i) => { tile.hidden = i >= 9; });
        more.addEventListener('click', () => {
          const expanded = more.getAttribute('aria-expanded') === 'true';
          photos.forEach((tile, i) => { tile.hidden = !expanded ? false : i >= 9; });
          more.setAttribute('aria-expanded', String(!expanded));
          more.textContent = expanded ? `View all ${photos.length} photos` : 'Show fewer photos';
        });
      }
      // Expired Instagram URLs fall back to a reserved image of this product.
      const useFallback = tile => {
        if (!tile.dataset.photoFallback) return false;
        const picture = tile.querySelector('img');
        picture.removeAttribute('srcset');
        picture.src = tile.dataset.photoFallback;
        picture.alt = tile.dataset.photoFallbackAlt;
        tile.dataset.photoFull = tile.dataset.photoFallback;
        tile.dataset.photoSource = 'shopify';
        tile.querySelector('[data-photo-date]').textContent = 'Product gallery';
        tile.querySelector('[data-photo-caption]').textContent = picture.alt;
        delete tile.dataset.photoFallback;
        return true;
      };
      photos.forEach(tile => {
        const picture = tile.querySelector('img');
        picture.addEventListener('error', () => useFallback(tile));
        if (picture.complete && !picture.naturalWidth) useFallback(tile);
      });
      const dialog = wall.querySelector('dialog');
      const image = dialog.querySelector('[data-photo-large]');
      const error = dialog.querySelector('[data-photo-error]');
      let current = 0;
      const show = index => {
        current = (index + photos.length) % photos.length;
        const tile = photos[current];
        error.hidden = true;
        image.hidden = false;
        image.alt = tile.querySelector('img').alt;
        image.src = tile.dataset.photoFull || tile.querySelector('img').src;
        dialog.querySelector('[data-view-date]').textContent = tile.querySelector('[data-photo-date]').textContent;
        dialog.querySelector('[data-view-caption]').textContent = tile.querySelector('[data-photo-caption]').textContent;
        dialog.querySelector('[data-photo-counter]').textContent = `${current + 1} / ${photos.length}`;
      };
      image.addEventListener('error', () => {
        if (useFallback(photos[current])) show(current);
        else { image.hidden = true; error.hidden = false; }
      });
      photos.forEach((tile, index) => tile.addEventListener('click', () => {
        show(index);
        document.querySelectorAll('[data-reel] video').forEach(video => video.pause());
        dialog.showModal();
        document.documentElement.classList.add('pp-photo-viewer-open');
      }));
      dialog.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => document.documentElement.classList.remove('pp-photo-viewer-open'));
      dialog.addEventListener('click', event => { if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      } });
      dialog.querySelectorAll('[data-photo-direction]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.photoDirection))));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
